"use strict";
/**
* @module
* @internal
* */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTC_OFFSET_REGEXP = exports.ISO8601_DATE_WITHOUT_MILLISECOND_FORMAT = exports.ISO8601_DATE_FOMART = void 0;
exports.ISO8601_DATE_FOMART = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
exports.ISO8601_DATE_WITHOUT_MILLISECOND_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
exports.UTC_OFFSET_REGEXP = /^([+-]\d{2}:\d{2})|Z$/;
